<div>
  <div mat-dialog-title>Feedback</div>
  <div mat-dialog-content>
    <p>What kind of feedback do you want to provide?</p>
    <mat-form-field style="width: 80%">
      <mat-select name="feedbackType" [ngModel]="feedback?.type" (ngModelChange)="onTypeChange($event)">
        @for (item of types; track item.key) {
          <mat-option [value]="item.key">
            {{ item.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (showRatingOptions()) {
      <div>
        <p>Rate your Experience:</p>
        <ul class="rating-options">
          @for (option of ratings; track option.value) {
            <li class="rating" [class.selected]="option.value === feedback?.rating">
              <button
                mat-icon-button
                (click)="onRatingSelected(option.value)"
                disableRipple="true"
                [attr.aria-label]="option.value">
                <mat-icon>
                  {{ option.category }}
                </mat-icon>
              </button>
            </li>
          }
        </ul>
      </div>
    }
    @if (showUrl()) {
      <div class="as-grey-text">
        <p>Reported Page:</p>
        <p>{{ currentUrl() }}</p>
      </div>
    }
    <p>What would you like to tell us?</p>
    <mat-form-field style="width: 100%">
      <textarea
        matInput
        id="message"
        required
        maxlength="500"
        wrap
        #message="ngModel"
        [ngModel]="feedback?.message"
        (ngModelChange)="onMessageChange($event)"></textarea>
      <mat-label for="message">Enter your feedback here</mat-label>
    </mat-form-field>
    <p>
      <mat-checkbox id="contact" checked [ngModel]="feedback?.contact" (ngModelChange)="onContactChange($event)">
        <mat-label for="contact">Please contact me about my feedback</mat-label>
      </mat-checkbox>
    </p>
  </div>

  <div mat-dialog-actions class="button-row right">
    <button mat-button id="cancel" (click)="cancelFeedback()">{{ 'Cancel' | translate: locale.language }}</button>
    <button mat-raised-button color="primary" id="ok" (click)="sendFeedback()" [disabled]="message.invalid">
      {{ 'OK' | translate: locale.language }}
    </button>
  </div>
</div>
